import { render } from "./MPreciosIndex.vue?vue&type=template&id=74a71386"
import script from "./MPreciosIndex.vue?vue&type=script&lang=js"
export * from "./MPreciosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/MPreciosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74a71386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74a71386', __exports__)) {
    api.reload('74a71386', __exports__)
  }
  
  module.hot.accept("./MPreciosIndex.vue?vue&type=template&id=74a71386", () => {
    api.rerender('74a71386', render)
  })

}


export default __exports__